import { useCallback } from 'react';
import { useMyInfo } from 'shared/src/queries';
import { usePostRedeemCoupon } from '../queries/usePostRedeemCoupon';
import { bridge } from 'shared/src/utils';
import { useSafeTimeout } from 'shared/src/hooks';
import type { Coupon } from '../../../../../../shared/src/api/marketService/getMarketCouponList';
import { useLogCompleteDownloadCoupon } from './useLogCompleteDownloadCoupon';

export const useOnPressRedeemCoupon = (marketId: number) => {
  const { data: myInfo } = useMyInfo();
  const { mutateAsync: postRedeemCoupon } = usePostRedeemCoupon(marketId);
  const logCompleteRedeemCoupon = useLogCompleteDownloadCoupon();
  const setSafeTimeout = useSafeTimeout();

  return {
    action: useCallback<(coupon: Coupon) => Promise<void>>(
      async coupon => {
        if (!myInfo) return;
        if (myInfo.is_anonymous) {
          bridge.assertLogin({});
          setSafeTimeout(() => {
            bridge.toast('로그인이나 회원가입이 필요해요');
          }, 200);
          return;
        }

        try {
          await postRedeemCoupon({ sno: coupon.sno });
          logCompleteRedeemCoupon({ coupon, isDownloadAll: false });
        } catch {
          /* onError에서 toast로 처리됨 */
        }
      },
      [logCompleteRedeemCoupon, myInfo, postRedeemCoupon, setSafeTimeout],
    ),
    loading: false,
  };
};
